import { Component, OnInit, Input } from '@angular/core';
import { LineOfBusiness } from 'src/app/models/line-of-business';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-line-of-business-card',
    templateUrl: './line-of-business-card.component.html',
    styleUrls: ['./line-of-business-card.component.scss'],
    standalone: false
})
export class LineOfBusinessCardComponent implements OnInit {

  @Input() lineOfBusiness: LineOfBusiness;

  RouterSegments = RouterSegments;
  tenant: string;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
  }

}
